// Stays here in the shell, a wrapper around the fed init
import { Store } from 'vuex';
import { logger } from '@app/logger';
import { getTemporaryMappings } from './compatibilityLayer';
import { getConfig } from '@superbet-group/web.lib.config';
import { createErrorGuardConfig } from '@utils/ErrorGuard/storeConfig';
import { initializeStores } from '@accountFederation/store/initializeStore';

export async function initializeAccountFederation(store: Store<unknown>): Promise<void> {
    try {
        initializeStores(store);
        const accountModule = await import('account/initializeFederation');

        await accountModule.initializeFederation({
            errorGuardConfig: createErrorGuardConfig(store),
            store,
            country: getConfig().countrySpecific.country,
            ...getTemporaryMappings(),
        });
    } catch (error) {
        logger.error(error as Error);
    }
}
